import noDataImage from "@assets/images/common/no-data.png";

const EmptyStateTradeOverview = ({ description }) => {
  return (
    <div className="d-block text-center w-100 p-5">
      <div className="card px-2 pt-4 pb-1 w-25 m-auto no-data-card border-0">
        <div className="text-center card-body p-2">
          <div className="header-image">
            <img className="img-fluid" src={noDataImage} alt={description} />
          </div>
          <p className="mt-4">{description}</p>
        </div>
      </div>
    </div>
  );
};

export default EmptyStateTradeOverview;
